import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { FC, ReactNode, Suspense } from 'react';

function queryErrorHandler(error: unknown): void {
  // JavaScriptでは例外に任意の値が投げられるため、errorはunknown型にしています（例: throw(5)）
  const id = 'react-query-error';
  const title =
    error instanceof Error ? error.message : 'error connecting to server';
  // 開発時のみ監視ツールやコンソールに出力します
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.warn(id, title);
  }

  // トースト表示などの通知処理をここで行う（必要に応じて実装）
}

function generateQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        onError: queryErrorHandler,
        retry: false,
        refetchOnReconnect: false,
        refetchOnWindowFocus: false,
        suspense: true,
      },
      mutations: {
        onError: queryErrorHandler,
      },
    },
  });
}

export const queryClient = generateQueryClient();

// テスト用React Query Client
export const createTestingQueryClientWrapper = (): FC => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: false,
      },
    },
    logger: {
      // 開発時のみログを出力
      log: (...args: unknown[]) => {
        if (process.env.NODE_ENV !== 'production') {
          // eslint-disable-next-line no-console
          console.log(...args);
        }
      },
      warn: (...args: unknown[]) => {
        if (process.env.NODE_ENV !== 'production') {
          // eslint-disable-next-line no-console
          console.warn(...args);
        }
      },
      error: () => {
        // エラーは無視する（テスト/ユニット環境で落とさないため）
      },
    },
  });
  return ({ children }: { children?: ReactNode }) => (
    <Suspense fallback={null}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </Suspense>
  );
};
